&nbsp;-&nbsp;<i>v{{appVersion}}</i>